import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceRss',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: [
        'serviceRssId',
        'rssName',
        'rssURL',
        'modifyButton',
        'deleteButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          serviceRssId: 'RSS ID',
          rssName: 'RSS名',
          rssURL: 'URL',
          modifyButton: '',
          deleteButton: ''
        },
        columnsClasses: {
          serviceRssId: 'wp-5',
          rssName: '',
          rssURL: '',
          modifyButton: 'wp-5 has-button',
          deleteButton: 'wp-5 has-button'
        },
        sortable: [
          'serviceRssId',
          'rssName',
          'rssURL',
          'Status'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      modifyTargetId: null,
      deleteTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
    this.initRegister()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceRss.categoryName,
      serviceName: state => state.serviceRss.serviceName,
      // model
      rssModel: state => state.serviceRss.rssModel,
      // form
      values: state => state.serviceRss.values,
      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      isRegister: 'serviceRss/isRegister',
      isModify: 'serviceRss/isModify'
    }),

    // title
    formTitle () {
      const id = Utility.getObjectArrayValue(this.rssModel, 'serviceRssUuid', this.modifyTargetId, 'serviceRssId')
      return this.isRegister ?
        this.categoryName + '登録' :
        this.categoryName + '変更（Id : ' + id + '）'
    },
    formButtonLabel () {
      return this.isRegister ? '登録' : '変更'
    },

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // input
    inpRssName: {
      get () {
        return this.values.inpRssName
      },
      set (value) {
        this.setInputValue({
          key: 'inpRssName',
          value: value
        })
      }
    },
    inpUrl: {
      get () {
        return this.values.inpUrl
      },
      set (value) {
        this.setInputValue({
          key: 'inpUrl',
          value: value
        })
      }
    },

    // disabled
    disableLedInterval () {
      return this.inpLedSetting !== 2
    },

    // validate
    inpRssNameIsValid () {
      return Validator.validText(this.inpRssName)
    },
    inpUrlIsValid () {
      return Validator.validText(this.inpUrl)
    },
    formIsValid () {
      return this.inpRssNameIsValid &&
        this.inpUrlIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
      // 削除
      if (this.confirmKey === 'delete') {
        if (to) this.deleteData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceRss/loadModel',
      initRegister: 'serviceRss/initRegister',
      initModify: 'serviceRss/initModify',
    }),
    ...mapMutations({
      setInputValue: 'serviceRss/setInputValue',
    }),

    init () {
      this.loading = true

      //
      let rssParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        rssParams: rssParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.rssModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // ファイル登録
    confirmData() {
      const id = Utility.getObjectArrayValue(this.rssModel, 'serviceRssUuid', this.modifyTargetId, 'serviceRssId')
      this.showConfirm({
        key: 'register',
        title: '',
        body: this.isRegister ?
          'この内容で' + this.categoryName + 'を登録しますか？' :
          '「Id : ' + id + '」の' + this.categoryName + '情報を変更しますか？'
      })
    },
    postData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        request: {
          rssName: this.inpRssName,
          rssURL: this.inpUrl
        }
      }
      if (this.isModify) {
        parameters.serviceRssUuid = this.modifyTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceRss'],
        [this.isRegister ?
          'v1ServiceRssPost' :
          'v1ServiceRssPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.isRegister ?
                '新しい' + this.categoryName + 'の登録' :
                this.categoryName + '情報の変更',
              body: this.isRegister ?
                this.categoryName + 'を登録しました。' :
                this.categoryName + 'を変更しました。'
            })

            // this.modifyTargetId = null
            if (this.isRegister) {
              this.initRegister()
            }

            // 一覧データを再読出し
            this.init()
            this.registerItem()
          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    deleteData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        serviceRssUuid: this.deleteTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceRss'],
        ['v1ServiceRssDelete'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + '情報の削除',
              body: this.categoryName + 'を削除しました。'
            })

            this.deleteTargetId = null
            this.modifyTargetId = null
            this.initRegister()

            // 一覧データを再読出し
            this.init()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    registerItem () {
      this.initRegister()
    },
    modifyItem (props) {
      this.modifyTargetId = props.row.serviceRssUuid
      this.initModify({
        data: props.row
      })
    },
    deleteItem (props) {
      this.deleteTargetId = props.row.serviceRssUuid
      // confirm
      const id = Utility.getObjectArrayValue(this.rssModel, 'serviceRssUuid', this.deleteTargetId, 'serviceRssId')
      this.showConfirm({
        key: 'delete',
        title: '',
        body: '「Id : ' + id + '」の' + this.categoryName + 'を削除しますか？',
        acceptLabel: '削除'
      })
    }
  }
}